import { ReactNode } from 'react';

import InfoTooltip from 'components/ui/info-tooltip';

import { IdDoTooltip } from '../extrato-modelo';

/** Textos de regra de cada tooltip, como na página antiga (texto de regulamento, não do design). */
const CONTEUDO: Record<IdDoTooltip, ReactNode> = {
  'jj-ate-2S2023': <p className="m-0">1 ponto JogaJunto equivale a 1 ponto Livelo.</p>,
  'jj-1S2024': (
    <p className="m-0">
      <b>Prêmio:</b> Pontos Livelo em quantidade equivalente à pontuação conquistada em “Meus Pontos” para todos os funcionários
      que finalizarem no <b>nível Jogando Junto.</b>
    </p>
  ),
  'jj-2S2024': <p className="m-0">Pontos Joga Junto x nível de reconhecimento.</p>,
  galeria: (
    <>
      <p className="m-0 mb-2">
        <b>Prêmio:</b> Pontos Livelo conquistados em “Meus Pontos” para todos os funcionários que finalizarem no{' '}
        <b>níveis #UAU, #MandouBem e #Valeu ,</b> sendo:
      </p>
      <ul className="m-0 list-disc pl-4">
        <li>
          <b>nível #UAU</b>: “Meus Pontos” multiplicados por 3 (três) em Pontos Livelo.
        </li>
        <li>
          <b>nível #MandouBem</b>: “Meus Pontos” multiplicados por 2 (dois) em Pontos Livelo.
        </li>
        <li>
          <b>nível #Valeu</b>: “Meus Pontos” multiplicados por 1,5 (um e meio) em Pontos Livelo.
        </li>
      </ul>
    </>
  ),
  cultura: (
    <p className="m-0">
      <b>Prêmio</b>: 2 mil pontos Livelo aos <b>5% melhor Classificados do grupo</b> em cada Dimensão da Cultura (Colaboração;
      Inovação, Foco no Cliente, Protagonismo ou Liderança Integradora).
    </p>
  ),
  realizacaoDestaque: <p className="m-0">Pontos Realização Destaque x Multiplicador por GFM.</p>,
  'coletiva-1S2023': (
    <>
      <p className="m-0 mb-2">Entenda como funciona o valor do prêmio Livelo nas etapas de apreciação:</p>
      <p className="m-0 mb-2">Etapa 3: 1.000 pontos Livelo</p>
      <p className="m-0 mb-2">Etapa 4: 2.000 pontos Livelo</p>
      <p className="m-0 mb-2">Etapa 5: 3.000 pontos Livelo</p>
      <p className="m-0 mb-2">Etapa Selo: 4.000 pontos Livelo</p>
      <p className="m-0">
        O Bônus se limita a um por fase para cada funcionário que participou de Realizações bonificadas com 600, 1.200, 2.400 ou
        3.600 pontos. Independentemente da quantidade de Realizações pontuadas naquela fase, o Bônus corresponderá à Realização
        que recebeu a maior pontuação.
      </p>
    </>
  ),
  'coletiva-2S2023': (
    <>
      <p className="m-0 mb-2">
        O valor da premiação coletiva é determinado com base na participação em realizações bonificadas nos níveis de apreciação 2
        ou 3.
      </p>
      <p className="m-0 mb-2">Se você participou de uma realização bonificada no nível 2, receberá até 2.000 pontos Livelo.</p>
      <p className="m-0 mb-2">Se você participou de uma realização bonificada no nível 3, receberá até 7.000 pontos Livelo.</p>
      <p className="m-0 mb-2">Se foi reconhecido com o Selo Realização Destaque, receberá até 13.000 pontos Livelo.</p>
      <p className="m-0">
        Se você participou de mais de uma realização bonificada em um mês, será considerada apenas a entrega de maior pontuação.
      </p>
    </>
  ),
  'coletiva-1S2024': (
    <>
      <p className="m-0 mb-2">
        <b>Prêmio:</b> Pontos Livelo aos participantes de Realizações Destaques bonificadas pela apreciação nível 2 ou 3 ou o
        Selo, conforme IN 403-1, item 7.2.7.10, sendo:
      </p>
      <ul className="m-0 list-disc pl-4">
        <li>
          <b>Bonificadas pela apreciação nível 2</b>: Até limite 2.000 (dois mil) pontos livelo.
        </li>
        <li>
          <b>Bonificadas pela apreciação nível 3</b>: Até 7.000 (sete mil) pontos Livelo.
        </li>
        <li>
          <b>Reconhecidas com Selo</b>: Até 13.000 (treze mil) pontos Livelo.
        </li>
      </ul>
    </>
  ),
  'coletiva-2S2025': (
    <p className="m-0">
      conforme IN 403-1 item <b>6.5.7.3.2</b> O total da premiação coletiva ao final do ciclo semestral se limitará a 80.000
      (oitenta mil) pontos, por funcionário.
    </p>
  ),
};

interface TooltipDoExtratoProps {
  id: IdDoTooltip;
  /** Título do cartão, para o nome do botão ("Como é calculado: …"). */
  titulo: string;
}

/** O tooltip de regra de um cartão do Extrato: o `InfoTooltip` com o texto do cartão. */
export default function TooltipDoExtrato({ id, titulo }: TooltipDoExtratoProps) {
  return <InfoTooltip rotulo={`Como é calculado: ${titulo}`}>{CONTEUDO[id]}</InfoTooltip>;
}
